import { render, staticRenderFns } from "./ReservationsHistory.vue?vue&type=template&id=17633ced&scoped=true&"
import script from "./ReservationsHistory.vue?vue&type=script&lang=js&"
export * from "./ReservationsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsHistory.vue?vue&type=style&index=0&id=17633ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17633ced",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17633ced')) {
      api.createRecord('17633ced', component.options)
    } else {
      api.reload('17633ced', component.options)
    }
    module.hot.accept("./ReservationsHistory.vue?vue&type=template&id=17633ced&scoped=true&", function () {
      api.rerender('17633ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Reservations/ReservationsHistory.vue"
export default component.exports